import React from 'react';
import { Box } from '@apia/theme';
import store from '../../../../../store';
import { remoteModalsActions } from '../../../../../store/remoteModalsSlice';
import { formatMessage } from '../../../../../utils/util';
import { Confirm } from '../../../../common';
import { TUploaderFileInfo } from '../../../../common/uploader/types';
import UploaderApi from '../../../../common/uploader/UploaderApi';
import Label from '../../../../layout/Label';
import FileTranslation from './FileTranslation';
import { translateModalId, TTranslateModal } from './TranslateModal';

export interface ITranslateFilesModal {
  api: UploaderApi;
  file: TUploaderFileInfo;
  langs: Record<number, string>;
}
export function isFileTranslation(
  data: TTranslateModal | ITranslateFilesModal,
): data is ITranslateFilesModal {
  return !!(data as ITranslateFilesModal).file;
}

const TranslateFilesModal = (props: ITranslateFilesModal) => {
  const handleConfirm = React.useCallback(() => {
    store.dispatch(remoteModalsActions.close(translateModalId));
  }, []);
  return (
    <Confirm confirmButtonText={window.BTN_CLOSE} onConfirm={handleConfirm}>
      <Box {...window.getVariant('layout.common.modals.translation.files')}>
        <Label>
          {formatMessage(window.LBL_TRANSLATIONS_FOR_FILE, {
            TOK1:
              props.file.docName ||
              props.file.name ||
              'NoFileName (Is it an error?)',
          })}
        </Label>
        {Object.entries(props.langs).map(([langId, langName]) => (
          <Box className="file_translation" key={langId}>
            {langName}
            <FileTranslation
              file={props.file}
              api={props.api}
              langId={Number(langId)}
            />
          </Box>
        ))}
      </Box>
    </Confirm>
  );
};

export default TranslateFilesModal;
